import { render } from "./NavbarSect.vue?vue&type=template&id=1ac9b112&scoped=true"
import script from "./NavbarSect.vue?vue&type=script&lang=js"
export * from "./NavbarSect.vue?vue&type=script&lang=js"

import "./NavbarSect.vue?vue&type=style&index=0&id=1ac9b112&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ac9b112"]])

export default __exports__